module.exports = __webpack_public_path__ + "static/media/fitnesstrainer-partnercover.35751cc2.svg";